module.exports = __webpack_public_path__ + "img/KE.dd8a91b8.svg";